import dynamic from 'next/dynamic';
const MoveHealthMobileAppScroller = dynamic(() => import('./MoveHealthMobileAppScroller'));
export default MoveHealthMobileAppScroller;
